/**
 * Remove todos os acentos da string
 * @param  {string} value
 * @returns string
 */
export function normalize(value: string): string {
  return value.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
}
